import { Component, OnInit, Input } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ApiService } from 'src/app/api/api.service';
import * as dayjs from 'dayjs';
import { AlertController, ModalController } from '@ionic/angular';
import { GlobalService } from 'src/app/api/global.service';
import { CompaniesContactsSelectPage as ContactsSelectPage } from 'src/app/modals/companies-contacts-select/companies-contacts-select.page';

@Component({
  selector: 'app-create',
  templateUrl: './create.page.html',
  styleUrls: ['./create.page.scss'],
})
export class CreatePage implements OnInit {

  @Input() project;
  @Input() task;

  items: MenuItem[];
  activeIndex: number = 0
  dayjs: any = dayjs;
  payment: any = {
    title: '',
    paid: false,
    send_now: true,
    send_date: '',
    due_date: '',
    description: '',
    client_description: '',
    internal_description: '',
    currency: 'CAD',
    tags: [],
    amount: null,
    status: 0,
    use_us: true,
    include_service_fee: false,
    has_schedule: false,
    schedule: [],
    payment_notification_users: [],
    send_to_all: true,
    auto_even_payments: true


  };
  add_tag = {
    text: '',
    colour: '#90ee90'
  }
  assigning_to_company = true;
  assigning_to_client = false;
  company: any;

  constructor(private apiService: ApiService, private modalController: ModalController, public globalService: GlobalService, private alertController: AlertController) { }


  ngOnInit() {
    this.payment.payment_notification_users = [];
    this.payment.send_date = dayjs().format('YYYY-MM-DD');
    this.payment.due_date = dayjs().add(1, 'week').format('YYYY-MM-DD');
    this.CheckIsCompany();

    var initial_item = {
      title: '',
      short_desc: '',
      send_now: true,
      send_date: '',
      due_date: '',
      amount: 0
    }
    this.payment.schedule.push(initial_item);
    this.items = [
      { label: 'Payment Setup' },
      { label: 'Add Payment Schedule' },
      { label: 'Review' }
    ];
  }

  async CheckIsCompany() {
    if (!this.project || !this.project.company) {
      this.assigning_to_company = false;
      return;
    }
    if (this.project.company[0].guid) this.assigning_to_company = true;

    if (this.assigning_to_company) {
      this.company = await this.apiService.get(`companies/${this.project.company[0].guid}`);
      this.company = this.company.data[0];
    }
  }


  GoToStep(step) {
    if (step == 1) this.MakePaymentsEqual();
    this.activeIndex = step;
  }

  async Close() {
    const isDirty = this.payment.title?.trim() || this.payment.amount;
    if (isDirty) {
      const alert = await this.alertController.create({
        header: 'Are you sure?',
        message: 'You have unsaved changes. If you cancel now, your work will be lost.',
        buttons: [
          { text: 'Keep Editing', role: 'cancel' },
          { text: 'Discard', role: 'destructive', handler: () => this.modalController.dismiss(null) }
        ]
      });
      await alert.present();
    } else {
      this.modalController.dismiss(null);
    }
  }

  async RemoveTag(tag) {
    const index = this.payment.tags.findIndex(item => item.text === tag.text);
    if (index !== -1) this.payment.tags.splice(index, 1);
  }

  async AddTag() {
    if (this.payment.tags.findIndex(item => item.text === this.add_tag.text) == -1) {
      this.payment.tags.push(JSON.parse(JSON.stringify(this.add_tag)));
      this.add_tag.text = '';
    }
    else {
      this.globalService.presentToastMessage('Tags already exists on this payment.', false);
    }

  }

  async AddSchedule() {
    var initial_item = {
      title: 'Payment ' + (this.payment.schedule.length + 1),
      short_desc: '',
      send_now: false,
      send_date: dayjs(this.payment.schedule[this.payment.schedule.length - 1].send_date).add(1, 'week').format('YYYY-MM-DD'),
      due_date: dayjs(this.payment.schedule[this.payment.schedule.length - 1].send_date).add(2, 'week').format('YYYY-MM-DD'),
      amount: null
    }
    this.payment.schedule.push(initial_item);
    this.MakePaymentsEqual();
  }

  async RemovePaymentSchedule(index) {
    this.payment.schedule.splice(index, 1);
    this.MakePaymentsEqual();
  }

  CalculateAmountRemaining() {
    var current_total = 0;
    this.payment.schedule.forEach(payment => {
      current_total += payment.amount;
    });
    current_total = +current_total.toFixed(2);
    return this.payment.amount - current_total;
  }

  //Take the payments and make them equal, add all reminders to the final payment
  MakePaymentsEqual() {
    if (!this.payment.auto_even_payments) return;
    const paymentAmount = this.payment.amount * 100;
    const numPayments = this.payment.schedule.length;
    const amountPerPayment = (paymentAmount / numPayments) / 100;

    for (let i = 0; i < numPayments; i++) {
      this.payment.schedule[i].amount = this.roundDownToTwoDecimalPlaces(amountPerPayment);
    }
    var current_total = 0;
    this.payment.schedule.forEach(payment => {
      current_total += payment.amount * 100;
    });
    var difference = (this.payment.amount * 100) - current_total;
    var last_payment = this.payment.schedule[this.payment.schedule.length - 1].amount * 100;
    last_payment += difference;
    this.payment.schedule[this.payment.schedule.length - 1].amount = this.roundUpToTwoDecimalPlaces(last_payment / 100);


  }

  formatAsCurrency(event: any) {
    event.target.value = (event.target.valueAsNumber).toFixed(2);
  }

  getDigitsAfterSecondDecimal(number) {
    const str = number.toString(); // convert the number to a string
    const index = str.indexOf('.') + 3; // find the index of the third decimal place
    return Number("0.00" + str.slice(index)); // extract the digits after the second decimal point as a number
  }

  roundUpToTwoDecimalPlaces(number) {
    return Math.ceil(number * 100) / 100;
  }
  roundDownToTwoDecimalPlaces(number) {
    return Math.floor(number * 100) / 100;
  }

  isValidPaymentSchedule(schedule) {
    return dayjs(schedule.due_date).isValid() && schedule.title != '' && schedule.amount > 0 && (dayjs(schedule.send_date).isValid() || schedule.send_now);
  }

  serviceFee(amount) {
    amount = amount * 100;
    var percentage_markup = (0.029 / (1 - 0.029)) + 1;
    var new_total = ((amount * percentage_markup) + (0.32 * 100)) / 100;
    new_total = new_total - (amount / 100);
    return +new_total.toFixed(2);
  }

  solveServiceFee(amount) {
    amount = amount * 100;
    var percentage_markup = (0.029 / (1 - 0.029)) + 1;
    var new_total = ((amount * percentage_markup) + (0.32 * 100)) / 100;
    return +new_total.toFixed(2);
  }

  totalServiceFee() {
    var total_service_fee = 0;
    this.payment.schedule.forEach(item => {
      total_service_fee += this.serviceFee(item.amount);
    });
    return total_service_fee;
  }

  async UseScheduleChange() {
    //If we are using the scheudle we want to set the first payment information automatically
    if (this.payment.has_schedule) {
      this.SetDefaultSchedule();
    }
  }


  SetDefaultSchedule() {
    this.payment.schedule[0].title = this.payment.title;
    this.payment.schedule[0].send_now = this.payment.send_now;
    this.payment.schedule[0].send_date = this.payment.send_date;
    this.payment.schedule[0].due_date = this.payment.due_date;
    this.payment.schedule[0].amount = this.payment.amount;

  }

  //Prompt to select clients
  async presentSelectClientsModal() {

    let project_client_copy = JSON.stringify(this.payment.payment_notification_users);
    const modal = await this.modalController.create({
      component: ContactsSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        company: this.project.company,
        selecting_for_company: false,
        selected_clients: this.payment.payment_notification_users,
        remove_clients: this.payment.payment_notification_users,
        in_clients: this.company.clients,
        target_header: 'Currently Selected'
      }
    })
    modal.onDidDismiss().then((data: any) => {
      if (data && data.data.clients) {
        this.payment.payment_notification_users = data.data.clients;
        console.log(this.payment.payment_notification_users);
      }
      else {
        this.payment.payment_notification_users = [...JSON.parse(project_client_copy)];
      }

    });
    return await modal.present()
  }

  async Create() {
    console.log(this.project);
    var posted_payment = {
      user_id: '',
      title: '',
      currency: '',
      amount: 0,
      status: false,
      include_service_fee: false,
      due_date: '',
      send_date: '',
      project_id: '',
      task_id: '',
      send_now: false,
      has_schedule: false,
      company_id: '',
      payment_schedule: [],
      send_to_all: false,
      use_us: true
    }

    posted_payment.title = this.payment.title;
    posted_payment.currency = this.payment.currency;
    posted_payment.amount = this.payment.amount * 100;
    posted_payment.status = this.payment.status;
    posted_payment.include_service_fee = this.payment.include_service_fee;
    posted_payment.due_date = this.payment.due_date;
    posted_payment.send_now = this.payment.send_now;
    posted_payment.has_schedule = this.payment.has_schedule;
    posted_payment.payment_schedule = this.payment.schedule;
    posted_payment.send_to_all = this.payment.send_to_all;
    posted_payment.use_us = this.payment.use_us;
    if (posted_payment.send_now) posted_payment.send_date = dayjs().toISOString();
    if (this.project) {

      //Check if this project is assigned to a company or task
      if(this.assigning_to_client) {
        posted_payment.user_id = this.project.client[0].guid;
      }
      else if (this.assigning_to_company) {
        posted_payment.company_id = this.project.company[0].guid;
      }
      posted_payment.project_id = this.project.guid;
    }
    if (this.task) {
      posted_payment.task_id = this.task.guid;
      if(this.assigning_to_client) {
        posted_payment.user_id = this.project.client[0].guid;
      }
      else if (this.assigning_to_company) {
        posted_payment.company_id = this.project.company[0].guid;
      }
    }

    let data: any = await this.apiService.post('payments', posted_payment);
    if(data.success) this.modalController.dismiss();
  }



}
